enum ConteudoQrCode {
    InformacoesManipulacao = 1,
    Codigo = 2,
}

export default ConteudoQrCode;
